import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  return (
    <Fragment>
      <PageLayout.Heading text="Gick inte att återställa lösenord" />
      <p>
        Det verkar som om återställningslänken inte längre är giltig. Testa att{' '}
        <Link to="/auth/reset-password/request" underline>
          begära en ny återställningslänk
        </Link>
        .
      </p>
    </Fragment>
  );
}
